'use strict';

$('.videoplayer').each(function (i, el) {

    var fileUrl = $(el).find('a').first().attr('href');
    var imageUrl = null;

    var jwOptions = {
        flashplayer: '/js/mediaplayer/player.swf',
        file: fileUrl,
        height: 286,
        width: 502,
        autostart: false,
        provider: 'http',
        'http.startparam': 'ec_seek',
        stretching: 'uniform',
        icons: false,
        skin: '/js/mediaplayer/skins/bekle/bekle.zip'
    };

    $(el).find('img').each(function (i, img) {
        var imgWidth = $(img).attr('width');
        var imgHeight = $(img).attr('height');

        if (imgWidth === undefined) {
            imgWidth = $(img).width();
        }

        if (imgHeight === undefined) {
            imgHeight = $(img).height();
        }

        jwOptions.image = imageUrl = $(img).attr('src');

        if ($(el).hasClass('responsive')) {
            jwOptions.width = '100%';

            switch (rnd(imgWidth / imgHeight, 2)) {
                case 1.33:
                    jwOptions.aspectratio = '4:3';
                    break;
                case 1.78:
                    jwOptions.aspectratio = '16:9';
                    break;
                case 1.85:
                    jwOptions.aspectratio = '37:20';
                    break;
                case 2.20:
                    jwOptions.aspectratio = '11:5';
                    break;
                case 2.35:
                    jwOptions.aspectratio = '47:20';
                    break;
                default:
                    jwOptions.aspectratio = '4:3';
                    break;
            }
        } else {
            jwOptions.width = imgWidth;
            jwOptions.height = imgHeight;
        }
    });

    jwplayer($(this).attr('id')).setup(jwOptions);
});

var pressApp = {
    header: {
        autostick: function autostick() {
            if ($('.commonHeader').first().hasClass("scroll")) {
                return;
            }

            var maxHeight = 0;
            $('.three_view').each(function (i, el) {
                var currHeight = $(el).height();

                maxHeight = Math.max(currHeight, maxHeight);
            });

            var availSpace = $(window).height() - 252;
            if (maxHeight > availSpace) {
                pressApp.header.unstick();
            } else {
                pressApp.header.stick();
            }
        },
        stick: function stick() {
            $('.commonHeader').css('position', 'fixed');
        },
        unstick: function unstick() {
            $('.commonHeader').css('position', 'absolute');
        }
    },
    resize: {
        resizeTimeout: null,
        throttler: function throttler() {
            if (!pressApp.resize.resizeTimeout) {
                pressApp.resize.resizeTimeout = setTimeout(function () {
                    pressApp.resize.resizeTimeout = null;
                    pressApp.resize.handler();
                    console.log("Throttler");
                }, 500);
            }
        },
        handler: function handler() {
            pressApp.header.autostick();
        }
    }
};

$(document).ready(function () {
    if ($("#homer").length > 0) {
        $("#homer").affix({
            offset: {
                top: $("#homer").offset().top
            }
        });
    }

    $('.scriptonly').show();
    //$('#navwrap li:has(ul)').doubleTapToGo();
    //$('.navwrap li:has(div.subnav)').pressTouchNav();

    $('.lefooter.fixed').each(function () {
        $('.social_icon, .pc_footer_nav').hide();
        $('#footer_open').addClass('enabled');
    });

    $('#footer_open').click(function (e) {
        e.preventDefault();

        $(this).hide();
        $('#footer_close').show();
        $('.social_icon, .link').show();

        var availSpace = $(window).height() - 252;
        if ($('.commonFooter').first().height() < availSpace) {
            $('.pc_footer_nav').css('display', 'flex');
        }
    });

    $('#footer_close').click(function (e) {
        e.preventDefault();

        $(this).hide();
        $('#footer_open').show();
        $('.social_icon, .pc_footer_nav, .link').hide();
    });

    $('#navburger a').click(function (e) {
        e.preventDefault();
        var el = $('.second_view').get(0);
        if ($(el).hasClass('show')) {
            $(el).removeClass('show');
        } else {
            $(el).addClass('show');
        }
    });

    window.addEventListener("resize", pressApp.resize.throttler, false);
    pressApp.resize.handler();
});